import { useGeneratedPricingCustomerDetailDataQuery } from '@sales-portal/domain/pricing/screens/customers/blocs/documents/customer-detail-data.generated';
import { useMemo } from 'react';

export const useCustomerDetailDataLoader = (
  supplierUUID: string | undefined,
  restaurantUUID: string,
) => {
  const { data, loading, error, refetch } =
    useGeneratedPricingCustomerDetailDataQuery({
      notifyOnNetworkStatusChange: true,
      skip: !restaurantUUID,
      variables: { restaurantUUID, supplierUUID },
    });

  return useMemo(
    () => ({
      data,
      error,
      loading,
      refetch,
    }),
    [data, error, loading, refetch],
  );
};
